// extracted by mini-css-extract-plugin
export default {"errorWrapper":"ErrorMessage_errorWrapper__EXz1V","boxWrapper":"ErrorMessage_boxWrapper__n6cW+","icon":"ErrorMessage_icon__hyLMY","errorText":"ErrorMessage_errorText__HBUoT"};